module.exports = __webpack_public_path__ + "img/9a8c76b.jpg";